import React, { useEffect, useState } from "react";
import { createSelector } from "reselect";
import { useNavigate } from "react-router-dom";
// Redux
import { useSelector } from "react-redux";
// Helpers and Hooks
import { isInvestCompany } from "helpers/Others/company_helper";
import { useGlobalHooks } from "hooks/useGlobalHooks";
// Config, Static Datas and Assets
import { RiCoinsFill, RiQuestionnaireFill } from "react-icons/ri";
import { FaFileContract, FaUserAlt, FaWallet } from "react-icons/fa";
import { FaFileLines } from "react-icons/fa6";
import { MdSpaceDashboard } from "react-icons/md";
import { userTypes } from "constants/layout";
import { getAppConfig } from "config/configInitializer";

const Navdata = () => {
  const history = useNavigate();
  const { t } = useGlobalHooks();

  const config = getAppConfig();
  const { company } = config;

  const [isInvest, setIsInvest] = useState(false);

  useEffect(() => {
    (async () => {
      const invest = await isInvestCompany();
      setIsInvest(invest);
    })();
  }, []);

  //state data
  const [isDashboard, setIsDashboard] = useState<boolean>(false);
  const [isApps, setIsApps] = useState<boolean>(false);
  const [isAuth, setIsAuth] = useState<boolean>(false);
  const [isPages, setIsPages] = useState<boolean>(false);
  const [contracts, setContracts] = useState<boolean>(false);
  const [payment, setPayment] = useState<boolean>(false);
  const [support, setSupport] = useState<boolean>(false);
  const [account, setAccount] = useState<boolean>(false);
  const [reports, setReports] = useState<boolean>(false);
  const [rebates, setRebates] = useState<boolean>(false);
  const [commission, setCommission] = useState<boolean>(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  const selectLayoutStateAuth = (state: any) => state.Dashboard;
  const selectLayoutPropertiesAuth = createSelector(
    selectLayoutStateAuth,
    (state) => ({
      authData: state.authData,
    })
  );

  const { authData } = useSelector(selectLayoutPropertiesAuth);
  const isSouthAfrica = authData?.countryOfResidenceId == "192";

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
      document.body.classList.add("twocolumn-panel");
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "Contracts") {
      setContracts(false);
    }
    if (iscurrentState !== "Payment") {
      setPayment(false);
    }
    if (iscurrentState !== "Support") {
      setSupport(false);
    }
    if (iscurrentState !== "Account") {
      setAccount(false);
    }
    if (iscurrentState !== "Rebates") {
      setRebates(false);
    }
    if (iscurrentState !== "Commission") {
      setCommission(false);
    }
    if (iscurrentState !== "Reports") {
      setReports(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isApps,
    isAuth,
    isPages,
    contracts,
    payment,
    support,
    account,
    reports,
    rebates,
  ]);

  const menuItems: any = [
    // Common Account Settings
    {
      id: "account",
      label: t("account"),
      icon: <FaUserAlt size={22} />,
      link: "#",
      roles: ["Partner", "Seller"],
      click: function (e: any) {
        e.preventDefault();
        setAccount(!account);
        setIscurrentState("Account");
        updateIconSidebar(e);
      },
      stateVariables: account,
      subItems:
        authData?.userRoleType === userTypes.PARTNER_ROLE
          ? isInvest
            ? [
                {
                  id: "profile",
                  label: t("profile"),
                  link: "/profile",
                  parentId: "account",
                },
              ]
            : [
                {
                  id: "profile",
                  label: t("profile"),
                  link: "/profile",
                  parentId: "account",
                },
                {
                  id: "wallet-address",
                  label: t("walletaddress"),
                  link: "/wallet-address",
                  parentId: "account",
                },
              ]
          : [
              {
                id: "",
                label: t(""),
                link: "",
                parentId: "",
              },
            ],
    },
    // Common Dashboard Settings
    {
      id: "dashboard",
      label: t("dashboard"),
      icon: <MdSpaceDashboard size={22} />,
      link: "/dashboard",
      roles: ["Partner", "Seller"],
      click: function (e: any) {
        e.preventDefault();
        setIscurrentState("Dashboard");
        setIsDashboard(!isDashboard);
        updateIconSidebar(e);
      },
    },
    // Partner Contract Settings
    {
      id: "contract",
      label: isInvest ? t("earningplan") : t("contracts"),
      icon: <FaFileContract size={22} />,
      link: "#",
      roles: ["Partner"],
      click: function (e: any) {
        e.preventDefault();
        setContracts(!contracts);
        setIscurrentState("Contracts");
        updateIconSidebar(e);
      },
      stateVariables: contracts,
      subItems: [
        {
          id: "my-structure",
          label: isInvest ? t("mycontracts") : t("mystructure"),
          link: "/contract",
          parentId: "contract",
        },
      ],
    },
    // Sales Contract Settings
    {
      id: "contract",
      label: t("mystructure"),
      icon: <FaFileContract size={22} />,
      link: "#",
      roles: ["Seller"],
      click: function (e: any) {
        e.preventDefault();
        setContracts(!contracts);
        setIscurrentState("Contracts");
        updateIconSidebar(e);
      },
      stateVariables: contracts,
      subItems: [
        {
          id: "structure-details",
          label: t("structuredetails"),
          link: "/sales-structure-details",
          parentId: "contract",
        },
      ],
    },
    // Partner Payment Settings
    {
      id: "payment",
      label: t("payment"),
      icon: <FaWallet size={22} />,
      link: "#",
      roles: ["Partner"],
      click: function (e: any) {
        e.preventDefault();
        setPayment(!payment);
        setIscurrentState("Payment");
        updateIconSidebar(e);
      },
      stateVariables: payment,
      subItems: [
        {
          id: "payment-history",
          label: t("transactionhistory"),
          link: "/transaction-history",
          parentId: "payment",
        },
      ],
    },
    // Sales Payment Settings
    {
      id: "payment",
      label: t("payment"),
      icon: <FaWallet size={22} />,
      link: "#",
      roles: ["Seller"],
      click: function (e: any) {
        e.preventDefault();
        setPayment(!payment);
        setIscurrentState("Payment");
        updateIconSidebar(e);
      },
      stateVariables: payment,
      subItems: [
        {
          id: "payment-history",
          label: t("transactionhistory"),
          link: "/sales-transaction-history",
          parentId: "payment",
        },
      ],
    },
    // Partner Rebates Settings
    {
      id: "rebates",
      label: isInvest ? t("commission") : t("rebates"),
      icon: <RiCoinsFill size={22} />,
      link: "#",
      roles: ["Partner"],
      click: function (e: any) {
        e.preventDefault();
        setRebates(!rebates);
        setIscurrentState("Rebates");
        updateIconSidebar(e);
      },
      stateVariables: rebates,
      subItems:
        authData.hasPnlShareContract == "True"
          ? [
              {
                id: "rebates",
                label: isInvest ? t("rebates") : t("volumerebates"),
                link: "/rebate",
                parentId: "rebates",
              },
              {
                id: "rebate-pnl",
                label: t("profitshare"),
                link: "/rebate-pnl",
                parentId: "rebates",
              },
            ]
          : [
              {
                id: "rebates",
                label: isInvest ? t("rebates") : t("volumerebates"),
                link: "/rebate",
                parentId: "rebates",
              },
            ],
    },
    // Sales Rebates/Commission Settings
    !isSouthAfrica && {
      id: "commission",
      label: t("commission"),
      icon: <RiCoinsFill size={22} />,
      link: "/sales-commission",
      roles: ["Seller"],
      click: function (e: any) {
        e.preventDefault();
        setCommission(!commission);
        setIscurrentState("Commission");
        updateIconSidebar(e);
      },
      stateVariables: commission,
    },
    // Partner Reports Settings
    {
      id: "reports",
      label: t("reports"),
      icon: <FaFileLines size={22} />,
      link: "#",
      roles: ["Partner"],
      click: function (e: any) {
        e.preventDefault();
        setReports(!reports);
        setIscurrentState("Reports");
        updateIconSidebar(e);
      },
      stateVariables: reports,
      subItems: [
        {
          id: "client-list",
          label: t("clientlist"),
          link: "/client-list",
          parentId: "reports",
        },
        {
          id: "sub-ib-list",
          label: t("subiblist"),
          link: "/sub-ib-list",
          parentId: "reports",
        },
        ...(!isInvest
          ? [
              {
                id: "money-transfer-report",
                label: t("moneytransferreport"),
                link: "/money-transfer-report",
                parentId: "reports",
              },
            ]
          : []),
        {
          id: "closed-trades",
          label: t("closedtradesreport"),
          link: "/closed-trades",
          parentId: "reports",
        },
        ...(!isInvest
          ? [
              {
                id: "deals",
                label: t("dealsreport"),
                link: "/deals",
                parentId: "reports",
              },
            ]
          : []),
        {
          id: "open-position-report",
          label: t("openpositionreport"),
          link: "/open-position-report",
          parentId: "reports",
        },
        ...(!isInvest
          ? [
              {
                id: "equity-report",
                label: t("equityreport"),
                link: "/equity-report",
                parentId: "reports",
              },
            ]
          : []),
        {
          id: "top-clients-report",
          label: t("topclientsreport"),
          link: "/top-clients-report",
          parentId: "reports",
        },
      ],
    },
    // Sales Reports Settings
    {
      id: "reports",
      label: t("reports"),
      icon: <FaFileLines size={22} />,
      link: "#",
      roles: ["Seller"],
      click: function (e: any) {
        e.preventDefault();
        setReports(!reports);
        setIscurrentState("Reports");
        updateIconSidebar(e);
      },
      stateVariables: reports,
      subItems: [
        {
          id: "sales-list",
          label: t("saleslist"),
          link: "/sales-list",
          parentId: "reports",
        },
        {
          id: "sales-partner-list",
          label: t("partnerlist"),
          link: "/sales-partner-list",
          parentId: "reports",
        },
        {
          id: "sales-client-list",
          label: t("clientlist"),
          link: "/sales-client-list",
          parentId: "reports",
        },
        {
          id: "sales-money-transfer-report",
          label: t("moneytransferreport"),
          link: "/sales-money-transfer-report",
          parentId: "reports",
        },
        {
          id: "sales-equity-report",
          label: t("equityreport"),
          link: "/sales-equity-report",
          parentId: "reports",
        },
      ],
    },
    // Common Support Settings
    !isInvest && {
      id: "support",
      label: t("support"),
      icon: <RiQuestionnaireFill size={22} />,
      link: "#",
      roles: ["Partner", "Seller"],
      click: function (e: any) {
        e.preventDefault();
        setSupport(!support);
        setIscurrentState("Support");
        updateIconSidebar(e);
      },
      stateVariables: support,
      subItems: [
        {
          id: "help-center",
          label: t("helpcenter"),
          link: company.FAQ_URL,
          parentId: "support",
          external: true,
        },
        {
          id: "contact-us",
          label: t("contactus"),
          link: "/contact-us",
          parentId: "support",
        },
      ],
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
